module.exports = __webpack_public_path__ + "static/media/americanExpress.da735f1f.svg";